<!--Use it to display info and error to user, use 
  this.$eventBus.emit("displayinfo", {object with data example: title: "Title to display"})-->

<script lang="ts">
import { useGlobalStore } from "@/stores/globalStore";
export default {
  setup() {
    const globalStore = useGlobalStore();
    return { globalStore };
  },
  props: {
    show: Boolean,
    title: String,
    text: String,
    route: String,
    textlink: String,
    error: Boolean,
    valid: Boolean,
    rawMessage: String,
  },
  methods: {
    close() {
      this.globalStore.ModalInfoData.show = false;
      this.globalStore.emptyModalInfoData();
    },
    changeRoute() {
      this.globalStore.ModalInfoData.show = false;
      this.$router.push("/" + this.globalStore.ModalInfoData.route);
    },
  },
};
</script>

<template>
  <div v-if="show" class="show">
    <div class="modal" @click="close">
      <div
        class="modal-center"
        :class="[valid ? 'valid' : '', error ? 'invalid' : '']"
      >
        <div class="modal-content">
          <div class="modal-header">
            <CheckIcon
              class="modal-icon"
              :class="[valid ? 'valid-modal' : '']"
              v-if="valid"
            />
            <WarningIcon
              class="modal-icon"
              :class="[error ? 'error-modal' : '']"
              v-if="error"
            />
            <InfoIcon class="modal-icon" v-if="!error && !valid" />
            <div
              class="modal-title"
              v-if="title"
              :class="[valid ? 'valid-modal' : '', error ? 'error-modal' : '']"
            >
              {{ title }}
            </div>
          </div>
          <p class="modal-p" v-if="text">
            {{ text }}
          </p>
          <p class="raw-message" v-if="rawMessage">
            <span class="raw-message-title">{{$t('errors.default-title')}} :</span>
            {{ rawMessage }}
          </p>
          <div class="button-container">
            <button
              class="modal-button"
              :class="[valid ? 'valid-modal' : '']"
              @click.prevent="close"
            >
              OK
            </button>
            <button
              class="modal-button"
              :class="[valid ? 'valid-modal' : '']"
              @click.prevent="changeRoute"
              v-if="textlink && route"
            >
              {{ textlink }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.show {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 120;
}
.valid-modal {
  color: var(--success);
}
.error-modal {
  color: var(--error);
}
.invalid {
  border: 1px solid var(--border-text);
}

.valid {
  border: 1px solid var(--border-text);
}

.modal {
  position: fixed;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #0005;
  z-index: 130;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}
.modal-header {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 1rem 0 2rem;
}
.modal-title {
  text-transform: uppercase;
  margin-left: 8px;
  font-weight: bold;
  font-size: 1.1rem;
  line-height: 15px;
}
.modal-p {
  color: var(--text);
  line-height: 1.1rem;
  font-weight: 400;
  text-align: center;
  margin: 2rem 0;
}
.modal-content {
  background: var(--bg);
  padding: 15px 40px;
  width: 100%;
  border-radius: 10px;
  text-align: center;
  transition: all 0.2s ease-in-out;
}
.modal-center {
  border: 1px solid var(--border-text);
  margin-top: 2rem;
  border-radius: 10px;
  width: 90%;
  max-width: 700px;
  height: fit-content;
  display: flex;
  justify-content: center;
  align-items: center;
  background: var(--bg2);
}
.button-container {
  display: flex;
  flex-direction: row-reverse;
  width: 100%;
  justify-content: space-between;
  margin-top: 15px;
}
.modal-button {
  color: var(--text);
  border: none;
  background: var(--factstory);
  border-radius: 10px;
  padding: 0.5rem 2rem;
  font-weight: bold;
  font-size: 1.1rem;
  margin: 0 auto 1rem;
  transition: all 0.2s ease-in-out;
}
.modal-button:hover {
  cursor: pointer;
  background: var(--blue-marine);
}
.modal-icon {
  width: 20px;
  height: 20px;
}
.raw-message {
  position: relative;
  background-color: var(--bg2);
  border-radius: .5rem;
  padding: 2rem 1rem 1rem 1rem;
  text-align: left;
  font-size: 0.95em;
  color: var(--text-low-emphasis);
}
.raw-message-title {
  color: var(--error);
  position: absolute;
  font-weight: bold;
  top: .6rem;
  left: .7rem;
  margin-right: .5rem;
}
@media screen and (min-width: 800px) {
  .modal-center {
    width: 50%;
  }
}
</style>
